import React, { useRef, useState, useEffect } from "react";

function Loader({ isReady, onComplete }) {
  const [hidden, setHidden] = useState(false);
  const [fading, setFading] = useState(false);
  const fadingRef = useRef(false);

  useEffect(() => {
    if (isReady && !fadingRef.current) {
      fadingRef.current = true;
      setFading(true);
      const t = setTimeout(() => {
        setHidden(true);
        if (onComplete) onComplete();
      }, 350);
      return () => clearTimeout(t);
    }
  }, [isReady, onComplete]);

  if (hidden) return null;

  return (
    <div className={`custm-loader${fading ? " nc-loader-fadeout" : ""}`}>
      <img src="/assets/video/nomadiccare_splash.gif" alt="Loading" />
    </div>
  );
}

export default Loader;
